import { useCallback } from 'react'

import { F0Alert, F0Box } from '@factorialco/f0-react'
import { DiscardOutdatedTaskDocument } from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import i18n from 'modules/core/lib/i18n'

import {
  TaskActionsHook,
  TaskCustomComponent,
  TaskDefinition,
} from 'modules/inbox_tasks/lib/abstraction'
import { trackDiscardInboxTask } from 'modules/inbox_tasks/lib/events'
import { DiscardWarningAlert } from 'modules/inbox_tasks/tasks/discard/DiscardWarningAlert'

const DiscardTaskContent: TaskCustomComponent = ({ assigneesTotalCount }) => {
  return (
    <F0Box display="flex" flexDirection="column" gap="lg">
      <F0Alert
        variant="info"
        title={i18n.t('tasks.discard_task.resource_unavailable_title')}
        description={i18n.t('tasks.discard_task.resource_unavailable_description')}
      />
      <DiscardWarningAlert assigneesTotalCount={assigneesTotalCount} />
    </F0Box>
  )
}

const useDiscardActions: TaskActionsHook = ({ taskId }) => {
  const [discardTask] = useMutation(DiscardOutdatedTaskDocument, {
    extractorFn: (data) => data.tasksMutations.discardOutdatedTasksInboxTask,
  })

  const onClickPrimaryAction = useCallback(
    async ({ taskId: id }: { taskId: string }) => {
      trackDiscardInboxTask({ category: undefined })
      await discardTask({ variables: { taskId: id } })
      return true
    },
    [discardTask]
  )

  return {
    onClickPrimaryAction,
    dropdownActions: [
      {
        value: 'discard',
        label: i18n.t('tasks.mark.as', {
          status: i18n.t('tasks.status.discarded').toLowerCase(),
        }),
      },
    ],
  }
}

export const DiscardTaskDefinition: TaskDefinition = {
  component: DiscardTaskContent,
  useActions: useDiscardActions,
}
